import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Component style
import './TweetCard.scss';

// Images
import RetweetIcon from '../../../assets/icons/retweet.svg';
import RetweetIconWhite from '../../../assets/icons/retweet_white.svg';

// Utils, const & misc
import {formatDateStringToNiceHumanDate} from '../../../utils/utils';
import parseTweeTtext from '../../../utils/tweetParser';

// Context
import ThemeContext from '../../../contexts/ThemeContext';

import ThemedLink from '../../uiElements/ThemedLink';

class TweetsCard extends Component {

	static contextType = ThemeContext;

	render() {
		let {id_str, created_at} 		= this.props.tweetData,
			hasBeenRetweeted 			= this.props.tweetData.retweeted_status,
			{text} 						= hasBeenRetweeted ? this.props.tweetData.retweeted_status : this.props.tweetData;

		return (
			<div className={`tweetCard ${this.context.isDarkTheme ? 'tweetCard--dark' : ''}`}>
				<div className="tweetContent">
					<div className="tweetContent__wrapper">
						<div
							className="tweetContent__text"
							dangerouslySetInnerHTML={{__html: parseTweeTtext(text, this.context.isDarkTheme)}}/>
						{
							(() => {
								if( hasBeenRetweeted )
									return (
										<div className="tweetContent__retweetedContainer">
											<img src={ this.context.isDarkTheme ? RetweetIconWhite : RetweetIcon} className="tweetContent__retweetIcon" alt="retweeted" />
											<ThemedLink
												href={`https://mobile.twitter.com/${this.props.tweetData.retweeted_status.user.screen_name}`}
												target="_blank"
												rel="noopener noreferrer"
											>
												@{this.props.tweetData.retweeted_status.user.screen_name}
											</ThemedLink>
										</div>
									);
								else
									return null;
							})()
						}

						<span className="tweetContent__date">
							 {formatDateStringToNiceHumanDate(created_at)}
						</span>
						<br/>
						<ThemedLink className="tweetContent__link"
						   href={`https://twitter.com/${this.props.twitterUser}/status/${id_str}`}
						   target="_blank"
						   rel="noopener noreferrer"
						>
							View on Twitter
						</ThemedLink>
					</div>
				</div>
			</div>
		);
	}
}

TweetsCard.propTypes = {
	tweetData: 		PropTypes.object.isRequired,
	twitterUser: 	PropTypes.string.isRequired
};

export default TweetsCard;